(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complete-the-look"] && !Shopify.designMode) return;
  try {
    (() => {
  function initBundleScroll(root) {
    root.querySelectorAll('.complete-the-look-section').forEach(section => {
      const container = section.querySelector('.carousel-container');
      const track = section.querySelector('.carousel-track');
      const prev = section.querySelector('.carousel-nav--prev');
      const next = section.querySelector('.carousel-nav--next');
      if (!container || !track || !prev || !next || container.dataset.scrollReady) return;
      container.dataset.scrollReady = 'true';
      const rtl = getComputedStyle(container).direction === 'rtl';
      const update = () => {
        const position = Math.abs(container.scrollLeft);
        const max = container.scrollWidth - container.clientWidth;
        prev.disabled = position <= 1;
        next.disabled = position >= max - 1;
      };
      const move = direction => {
        const card = track.querySelector('.product-card');
        const step = (card?.getBoundingClientRect().width || container.clientWidth) + (parseFloat(getComputedStyle(track).gap) || 0);
        container.scrollBy({left: direction * step * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      container.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(container);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBundleScroll(document), {once: true});
  } else {
    initBundleScroll(document);
  }
  document.addEventListener('shopify:section:load', event => initBundleScroll(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
